import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/auth';

export default {
    namespaced: true,
    state: {
        users: []
    },
    getters: {
        getUsers: state => state.users
    },
    mutations: {
        SET_USERS(state, users) {
            state.users = users;
        },
        ADD_USER(state, user) {
            state.users.push(user);
        },
        UPDATE_USER(state, payload) {
            Object.assign(state.users[payload.index], payload.user);
        },
        REMOVE_USER(state, user) {
            state.users = state.users.filter(item => item.uid !== user.uid);
        }
    },
    actions: {
        async loadUsers({commit}) {
            const manageUser = firebase.functions().httpsCallable('manageUser');
            const users = await manageUser({action: 'getAll'}).then(res => res.data.users);
            commit('SET_USERS', users)
        },
        async addUser({commit}, user) {
            const manageUser = firebase.functions().httpsCallable('manageUser');
            const res = await manageUser({action: 'create', payload: user});
            const newUser = Object.assign({}, res.data, {customClaims: {user: true}});
            commit('ADD_USER', newUser);
            return res.data.uid;
        },
        async updateUser({commit}, payload) {
            const manageUser = firebase.functions().httpsCallable('manageUser');
            await manageUser({action: 'update', payload: payload.user});
            commit('UPDATE_USER', payload);
        },
        async updateUserRole({commit}, payload) {
            const manageUser = firebase.functions().httpsCallable('manageUser');
            await manageUser({action: 'setRole', payload: payload.user});
            payload.user.customClaims = payload.user.role;
            commit('UPDATE_USER', payload);
        },
        async removeUser({commit}, user) {
            const manageUser = firebase.functions().httpsCallable('manageUser');
            await manageUser({action: 'delete', payload: user});
            commit('REMOVE_USER', user);
        }
    }
}
